"use strict";
exports.__esModule = true;
exports.logged = void 0;
//import fs from "fs";
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
function write(file, str) {
    // fs is not available on mobile
    //fs.appendFileSync(file, str);
}
function logged(api, file) {
    var proxy = new Proxy(api, {
        get: function (target, propKey, receiver) {
            if (typeof propKey === "symbol") {
                throw new Error("symbols not supported");
            }
            var targetValue = Reflect.get(target, propKey, receiver);
            if (typeof targetValue === "function") {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var result = targetValue.apply(this, args);
                    var log = function (answer) {
                        var summary = {
                            method: propKey,
                            params: args,
                            answer: answer
                        };
                        var summaryJson = JSON.stringify(summary).replace(/{"_bn":(".*?")}/g, "new PublicKey(Buffer.from($1, 'hex'))");
                        write(file, summaryJson + ",\n");
                    };
                    if (result instanceof Promise) {
                        return result.then(function (answer) {
                            log(answer);
                            return answer;
                        });
                    }
                    else {
                        log(result);
                        return result;
                    }
                };
            }
            else {
                return targetValue;
            }
        }
    });
    return proxy;
}
exports.logged = logged;
//# sourceMappingURL=logged.js.map